export class Address {
    address_line1: String;
    address_line2: String;
    address_line3: String;
    city: String;
    country: String;
    zip_code: String;
}